module.exports = __webpack_public_path__ + "img/about_something_new.a97b104e.svg";